<div class="table-responsive rounded border" style="background: #ffffff; border-color: #e2e8f0 !important;" *ngIf="data">
  <table class="table table-hover table-striped mb-0" style="font-size: 0.8125rem;">
    <thead style="background: var(--theme-primary, #123c53); color: #ffffff;">
      <tr>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Particulars</th>
        <th class="py-2 text-uppercase font-weight-bold" style="font-size: 0.75rem; letter-spacing: 0.5px;">Detail / Condition</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of data">
        <td class="font-weight-bold text-dark" style="width: 35%;">{{ row.Particulars }}</td>
        <td class="text-dark" style="white-space: normal !important; word-break: break-word !important;">{{ row.Detail }}</td>

      </tr>
    </tbody>
  </table>
</div>